module.exports = __webpack_public_path__ + "static/slider1-409faf68b43668461f3e434460ca82f9.jpg";